import React from 'react'
import {Grid} from "@mui/material";
import {styles} from './styles';
import {getHeaderCells} from './data';
import NoMatchingInvoicesFound from '../NoMatchingInvoicesFound';
import InfoCard from "../deprecatedUikit/InfoCard/InfoCard";

const BuyerInventoryTable = ({
    inventoryReports,
    loading,
    locationId,
    equipmentType,
    bookingNumber,
    sortBy,
    handleToggle,
    expandedItems
}) => {
  return (
    <Grid item mt={4} container flexDirection={'column'} sx={{
      ...(!inventoryReports.length && !loading) && styles.container,
  }}>
      {(!inventoryReports.length && !loading) ? (
          <Grid item sx={styles.showMessage}>
              {
                  sortBy ||  locationId || equipmentType || bookingNumber ? (
                      <NoMatchingInvoicesFound message='No matching records found.' />
                    ) : (
                        <NoMatchingInvoicesFound message="No input selected, To view results kindly select the data above"/>
                  )
              }
          </Grid>
      ) : (
          inventoryReports.map((inventory) => {
            return (
            <InfoCard
              key={inventory.id}
              headCells={getHeaderCells(inventory.assetType)}
              data={inventory}
              hasAction={false}
              loading={loading}
              handleToggle={handleToggle}
              collapse={expandedItems[inventory.id]}
          />
          )})
      )}
  </Grid>
  )
}

export default BuyerInventoryTable
